import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { useUpdateProject } from "@/entities/project";
import { getLocationSelectOptionValue } from "@/modules/location/location-select-parent";
import { parseDate } from "@/utilities/date";

import ProjectForm from "../ProjectForm";

const ProjectEdit = ({ model }) => {
  const { t } = useTranslation();

  const mutation = useUpdateProject(model.id);

  const initialValues = {
    name: model.name,
    reference: model.reference,
    description: model.description,
    users: model.users?.map(({ id, name, email }) => ({
      value: id,
      label: `${name} (${email})`,
    })),
    start_date: parseDate(model.start_date),
    due_date: parseDate(model.due_date),
    location: getLocationSelectOptionValue(model.ancestors),
    revised_interventions_cost: model.revised_interventions_cost,
  };

  return (
    <ProjectForm
      model={model}
      mutation={mutation}
      saveButtonLabel={t("global:update")}
      initialValues={initialValues}
    />
  );
};

ProjectEdit.propTypes = {
  model: PropTypes.object,
};

export default ProjectEdit;
